import { Flex, Spinner, Heading, useMediaQuery } from '@podiumhq/design-system';

import FullScreenSpinner from 'components/LoadingElements/FullScreenSpinner';

import AnimatedRoundedContentBox from '../../layout/AnimatedRoundedContentBox';
import useLoadingMessagesRotation from '../../hooks/useLoadingMessagesRotation';

const CreatingBusinessNumber = () => {
  const loadingMessage = useLoadingMessagesRotation();
  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');

  return (
    <>
      {isSmallerThan650px ? (
        <FullScreenSpinner
          backgroundColor="black.base"
          direction="column"
          position="relative"
          height="100vh"
          spinnerProps={{ size: 'lg', speed: '0.5s', color: 'black.lightest' }}
        >
          <Heading color="silver.lightest" {...headingStyles}>
            {loadingMessage}
          </Heading>
        </FullScreenSpinner>
      ) : (
        <Flex justifyContent="center">
          <AnimatedRoundedContentBox
            animationBoxProps={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
            height="325px"
            margin="18px"
            padding="90px"
          >
            <Spinner size="md" speed="0.5s" />
            <Heading color="black.lighter" {...headingStyles}>
              {loadingMessage}
            </Heading>
          </AnimatedRoundedContentBox>
        </Flex>
      )}
    </>
  );
};

const headingStyles = {
  fontSize: 'xl',
  fontWeight: 'medium',
  margin: '24px',
  textAlign: 'center',
};

export default CreatingBusinessNumber;
